"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlInput = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = require("react");
var _bero = _interopRequireWildcard(require("bero"));
var _componentIcon = require("@adl/component-icon");
var _componentFormNotice = require("@adl/component-form-notice");
var _bem = require("./bem");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["centered", "className", "defaultValue", "errorText", "hintText", "id", "labelCustomProps", "labelText", "noIcon", "onBlur", "onChange", "onFocus", "required", "showLabel", "tabIndexer", "valid", "value"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var GlInput = exports.GlInput = /*#__PURE__*/(0, _react.forwardRef)(function GlInput(_ref, ref) {
  var centered = _ref.centered,
    className = _ref.className,
    defaultValue = _ref.defaultValue,
    _ref$errorText = _ref.errorText,
    errorText = _ref$errorText === void 0 ? '' : _ref$errorText,
    hintText = _ref.hintText,
    id = _ref.id,
    labelCustomProps = _ref.labelCustomProps,
    labelText = _ref.labelText,
    noIcon = _ref.noIcon,
    onBlur = _ref.onBlur,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {
      return undefined;
    } : _ref$onChange,
    onFocus = _ref.onFocus,
    required = _ref.required,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? true : _ref$showLabel,
    tabIndexer = _ref.tabIndexer,
    valid = _ref.valid,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var internalRef = (0, _react.useRef)(null);
  var combinedRef = ref || internalRef;
  var withIcon = !noIcon && typeof valid === 'boolean';
  var error = valid === false;
  var displayError = error && errorText;
  var success = valid === true;
  var asteriskHTMLCode = '&#42;';
  var _useState = (0, _react.useState)(''),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    inputValue = _useState2[0],
    setValue = _useState2[1];
  var controlledValue = defaultValue ? undefined : inputValue;
  var handleOnBlur = function handleOnBlur(event) {
    if (onBlur) {
      onBlur(event);
    }
  };
  var handleOnChange = function handleOnChange(event) {
    var targetValue = event.target.value;
    setValue(targetValue);
    if (onChange) {
      onChange(event);
    }
  };
  var handleOnFocus = function handleOnFocus(event) {
    if (onFocus) {
      onFocus(event);
    }
  };
  (0, _react.useLayoutEffect)(function () {
    if (combinedRef && 'current' in combinedRef && combinedRef.current) {
      var inputElement = combinedRef.current;
      return (0, _utils.observeAndShiftSiblings)(inputElement);
    }
    return;
  }, [combinedRef]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _bero.default)('gl-form-item', {
      error: error,
      required: required,
      success: success
    }),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _bero.join)((0, _bem.bemInput)(), className),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", _objectSpread({
        id: id,
        name: id,
        ref: combinedRef,
        "aria-invalid": !valid,
        "aria-describedby": "".concat(id, "--text"),
        "aria-required": required,
        required: required,
        className: (0, _bem.bemInput)('field', {
          centered: centered,
          withIcon: withIcon
        }),
        tabIndex: tabIndexer,
        placeholder: " ",
        onBlur: handleOnBlur,
        onChange: handleOnChange,
        onFocus: handleOnFocus,
        defaultValue: defaultValue,
        value: value || controlledValue
      }, props)), /*#__PURE__*/(0, _jsxRuntime.jsxs)("label", _objectSpread(_objectSpread({
        htmlFor: id,
        id: "".concat(id, "_label"),
        className: !showLabel ? (0, _bero.join)((0, _bem.bemInput)('label', {
          centered: centered
        }), 'gl-screen-reader-only') : (0, _bem.bemInput)('label', {
          centered: centered
        })
      }, labelCustomProps), {}, {
        children: [labelText, required && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: (0, _bero.default)('gl-form-asterisk', {
            withoutPlaceholder: !showLabel
          }),
          dangerouslySetInnerHTML: {
            __html: asteriskHTMLCode
          }
        })]
      })), withIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentIcon.GlIconValidation, {
        success: success,
        iconClassName: (0, _bem.bemInput)('icon')
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_componentFormNotice.GlFormNotice, {
      error: Boolean(displayError),
      errorText: errorText,
      errorAttrs: {
        id: "".concat(id, "--error"),
        'aria-live': 'polite'
      },
      hintText: hintText,
      hintAttrs: {
        id: "".concat(id, "--text"),
        'aria-live': 'polite'
      }
    })]
  });
});